import React, { createContext, useContext, useState } from "react";
import propTypes from "prop-types";
import MediaLibraryComponent from "../../feature-module/media/MediaLibraryComponent"; // Import the MediaLibraryComponent

// Create the context
const MediaLibraryContext = createContext();

// Create a provider component
export const MediaLibraryProvider = ({ children }) => {
  const [isMediaLibraryOpen, setMediaLibraryOpen] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState([]);
  const [onSelectCallback, setOnSelectCallback] = useState(null);

  // Open the media library modal
  const openMediaLibrary = (callback) => {
    setOnSelectCallback(() => callback);
    setMediaLibraryOpen(true);
  };

  // Close the media library modal
  const closeMediaLibrary = () => setMediaLibraryOpen(false);

  // Handle media selection and update the state
  const handleMediaSelect = (selectedIds, selectedObjects) => {
    if (onSelectCallback) {
      onSelectCallback(selectedIds, selectedObjects);
    }
    setSelectedMedia(selectedObjects);
    setMediaLibraryOpen(false);
  };

  return (
    <MediaLibraryContext.Provider value={{ openMediaLibrary, selectedMedia }}>
      {children}
      <MediaLibraryComponent
        isOpen={isMediaLibraryOpen}
        onSelect={handleMediaSelect}
        onClose={closeMediaLibrary}
      />
    </MediaLibraryContext.Provider>
  );
};

// Define the prop types
MediaLibraryProvider.propTypes = {
  children: propTypes.node.isRequired,
};

// Custom hook to use the MediaLibrary context
// eslint-disable-next-line react-refresh/only-export-components
export const useMediaLibrary = () => useContext(MediaLibraryContext);
